// extracted by mini-css-extract-plugin
export default {"container":"JobPositionDetails-NameCell__container--pyTWO","name":"JobPositionDetails-NameCell__name--Sin6J","status":"JobPositionDetails-NameCell__status--poohI"};